"use client";
import { useState, useEffect, useRef } from 'react';
import Link from 'next/link';

interface ButtonAction {
  id: string;
  text: string;
  url: string;
}

interface HeroProps {
  data: {
    buttonsBottomActions: ButtonAction[];
  };
}

export const StickyCategoryNav = ({ data }: HeroProps) => {
  const [isSticky, setIsSticky] = useState(false);
  const [mainHeaderHeight, setMainHeaderHeight] = useState(0);
  const navRef = useRef<HTMLDivElement>(null);
  const placeholderRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const header = document.querySelector('header');
    const headerHeight = header?.offsetHeight || 0;
    setMainHeaderHeight(headerHeight);


    const handleScroll = () => {
      if (placeholderRef.current) {
        const placeholderPosition = placeholderRef.current.getBoundingClientRect();
        setIsSticky(placeholderPosition.top <= headerHeight);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const count = data.buttonsBottomActions.length;

  const gapClass = {
    1: "gap-40",
    2: "gap-32",
    3: "gap-24",
    4: "gap-16",
  }[count] || "gap-6";

  return (
    <>
      <div ref={placeholderRef} className={isSticky ? 'h-12' : 'h-0'}></div>
      
      <nav 
        ref={navRef}
        className={`bg-[#EBC6B9] shadow-sm border-b border-gray-200 py-3 px-6 transition-all duration-300 z-40
          ${isSticky 
            ? 'fixed top-0 left-0 w-full transform translate-y-0' 
            : 'relative transform -translate-y-full opacity-0'}`}
        style={{ 
          top: isSticky ? `${mainHeaderHeight}px` : '0',
          visibility: isSticky ? 'visible' : 'hidden',
          position: isSticky ? 'fixed' : 'static',
          display:isSticky ?'grid' : 'none',
          background: '#DBF2FF',
          justifyContent:'center'
        }}
      >
        <div className={`max-w-7xl mx-auto flex gap-6 overflow-x-auto pb-1 scrollbar-hide text-sm font-semibold text-[#032D60] ${gapClass}`}>
          {data.buttonsBottomActions.map((category) => (
            <Link
              key={category.id}
              href={category.url}
              className="hover:underline capitalize whitespace-nowrap"
            >
              {category.text}
            </Link>
          ))}
        </div>
      </nav>
    </>
  );
};